var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9498 0.878931C11.3402 1.26937 11.3403 1.9024 10.9499 2.29287L5.29386 7.94967C4.90334 8.34024 4.27014 8.34026 3.87959 7.94972L1.05075 5.12088C0.660285 4.73041 0.660285 4.09734 1.05075 3.70688V3.70688C1.44122 3.31641 2.07428 3.31641 2.46475 3.70688L4.58675 5.82887L9.53576 0.878994C9.92621 0.488473 10.5593 0.488445 10.9498 0.878931V0.878931Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.2b142b72c162991b3617c5b4ae261646.svg";
export { ForwardRef as ReactComponent };